import { createStore } from 'zustand';
import type { GroupResponsibleState, GroupResponsibleStore } from '@/scopes/account/group-responsible/domain/types';
import { setIn } from '@/scopes/common/domain/functions/objectDeepOperations';

const defaultInitialState: GroupResponsibleState = {
  bookingData: {
    group: {
      name: '',
      imgSrc: '',
      location: '',
      period: '',
    },
    labels: [{ text: '', type: 'info' }],
  },
  activeTab: 'participants',
  participants: {},
  rooms: {},
  buses: {},
  activeExtraInfoId: '',
  retrieveBookingData: {
    loading: true,
    error: false,
  },
};

export const groupResponsibleStore = createGroupResponsibleStore();

export function createGroupResponsibleStore(initialState: GroupResponsibleState = defaultInitialState) {
  return createStore<GroupResponsibleStore>((set) => ({
    ...initialState,
    initialize: (state) => {
      set(() => state);
    },

    setIn: (path, value) => {
      set((state) => setIn(state, path, value) as GroupResponsibleState);
    },

    changeTab: (tab) => {
      set((state) => ({ ...state, activeTab: tab }));
    },

    changeExtraInfoId: (id) => {
      set((state) => ({ ...state, activeExtraInfoId: id }));
    },
  }));
}
